export enum CategoriesEnum {
  InitFetchCategories = 'initFetchCategories',
  SuccessFetchCategories = 'successFetchCategories',
  FailFetchCategories = 'failFetchCategories',
  CleanCategoriesData = 'cleanCategoriesData',
  CleanCategoriesAlerts = 'CleanCategoriesAlerts',
}
